export default __webpack_public_path__ + "static/media/crypto_motors.af0c1b22.svg";